<template>
  <div class="h-full relative">
    <div
      v-if="isVisible"
      class="absolute h-full w-full flex flex-wrap top-0 left-0 overflow-hidden z-40"
    >
      <div class="w-1/2 shadow-lg" :style="{ backgroundColor: bgColor }">
        <div class="flex justify-between px-12 mt-4">
          <RandomText class="text-6xl"></RandomText>
          <div
            @click="infoShow"
            class="flex justify-end cursor-pointer creu-in"
          >
            <Icon icon="iwwa:close" width="55px" weight="light" />
          </div>
        </div>

        <fidelio-process
          :process="process"
          :processInfo="processInfo"
        ></fidelio-process>
      </div>
      <div class="w-1/2 opacity-60" :style="{ backgroundColor: bgColor }">
        <div
          class="w-full h-full opacity-20"
          :style="{ backgroundColor: bgColor }"
        ></div>
      </div>
    </div>
    <div class="flex flex-col h-full justify-between">
      <div class="flex justify-between">
        <div class="flex z-50 items-end p-4">
          <RandomText class="text-3xl">Units x Educar</RandomText>
          <RandomText class="text-xl text-gray-400 pl-1"
            >Web developer</RandomText
          >
        </div>
      </div>
      <div>
        <RandomText class="cursor-pointer text-3xl p-5" @click="processShow"
          >Process</RandomText
        >
      </div>
    </div>

    <slider-projects :slides="slides" />
  </div>
</template>

<script>
import SliderProjects from "@/components/SliderProjects.vue";
import FidelioProcess from "@/components/FidelioProcess.vue";
import RandomText from "@/components/RandomText.vue";

export default {
  name: "App",
  components: {
    SliderProjects,
    FidelioProcess,
    RandomText,
  },
  props: {
    bgColor: {
      type: String,
      required: true,
      default: "rgb(255, 255, 255)",
    },
  },
  data() {
    return {
      isVisible: false,
      slides: [
        {
          type: "text",
          content:
            "En aquest projecte, vaig ser l'encarregada de la configuració de WordPress per a la pàgina web de Units X Educar. El disseny de la web ja venia definit prèviament, i la meva tasca va consistir en implementar-lo creant una plantilla específica que seguís exactament el disseny preestablert. ",
        },
        {
          type: "image",
          content: "/img/units/units1.png",
        },
        {
          type: "image",
          content: "/img/units/units2.png",
        },
        {
          type: "image",
          content: "/img/units/units3.png",
        },
        {
          type: "image",
          content: "/img/units/units4.png",
        },
        {
          type: "image",
          content: "/img/units/units5.png",
        },
        {
          type: "image",
          content: "/img/units/units6.png",
        },
      ],
      process: [
        {
          text: "Per fer-ho, vaig utilitzar el plugin Themify Builder, que em va permetre adaptar i personalitzar les diferents seccions de manera que el resultat final fos fidel al concepte original i alhora funcional per als usuaris.",
        },
        {
          text: "A més de la configuració del lloc web, vaig implementar una agenda visible utilitzant el plugin Pie Calendar. Aquest sistema permet als coordinadors del projecte Units X Educar afegir fàcilment esdeveniments i activitats directament al calendari en línia. D'aquesta manera, es facilita la gestió de les activitats, oferint una eina intuïtiva per actualitzar el calendari i mantenir informats als usuaris de la web sobre les diferents iniciatives i esdeveniments que s'organitzen.",
        },
        {
          text: "La pàgina web de Units X Educar ha estat dissenyada pensant tant en usuaris de web com de mòbil. Per garantir una experiència òptima en qualsevol dispositiu, he implementat un disseny responsive que s'adapta automàticament a diferents mides de pantalla, mantenint la usabilitat i l'accessibilitat tant en ordinadors com en telèfons mòbils i tauletes. Això assegura que els coordinadors i usuaris puguin accedir a la informació i l'agenda des de qualsevol lloc i en qualsevol moment, sense perdre funcionalitat ni claredat en la interfície.",
        },
      ],
      processInfo: [
        {
          title: "Client:",
          subtitle: "Museum of Ethnography Neuchâtel (MEN)",
        },
        {
          title: "Scenography:",
          subtitle: "Anna Jones, Elfyn Round, Raphaël von Allmen",
        },
        {
          title: "Graphics:",
          subtitle: "Graziella Paiano",
        },
        {
          title: "Light:",
          subtitle: "Lumière Électrique",
        },
        {
          title: "Photography:",
          subtitle: "Prune Simon-Vermot",
        },
      ],
    };
  },
  methods: {
    processShow() {
      this.isVisible = !this.isVisible;
    },
    infoShow() {
      this.isVisible = !this.isVisible;
    },
  },
};
</script>

<style>
.creu-in {
  animation: fadeInOut 5s ease-in-out infinite;
}

@keyframes fadeInOut {
  0% {
    transform: translateY(0) scale(0.7);
    opacity: 100%;
  }
  50% {
    transform: translateY(90vh) scale(0.2);
    opacity: 0%;
  }
  100% {
    transform: translateY(0) scale(0.7);
    opacity: 100%;
  }
}
</style>

